/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UspsAddressRequest } from '../models/UspsAddressRequest';
import type { UspsAddressValidationResult } from '../models/UspsAddressValidationResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AddressService {
  /**
   * Verifies the validity of a US address using the USPS address validation service.
   * @param requestBody
   * @returns UspsAddressValidationResult OK
   * @throws ApiError
   */
  public static verifyUspsAddress(
    requestBody?: UspsAddressRequest,
  ): CancelablePromise<UspsAddressValidationResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Address/verify',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `Internal Server Error`,
      },
    });
  }
}
